import React, {Fragment} from 'react';
import {Seo, Breadcrumb, ScrollTopBtn} from '../components';
import {
  HeaderOne, 
  ContactTwo, 
  FooterTwo,
  FooterThree,
  HeaderFour
} from '../containers';

const Contact = () => (
  <Fragment>
    <Seo title="Contact Us" />
    <HeaderFour />
    <Breadcrumb pageName="Contact Us" bgImage="images/breadcumb/breadcumb-bg.jpg" />
    <ContactTwo className="space-top space-extra-bottom"/>
    <FooterThree/>
    <ScrollTopBtn/>
  </Fragment>
);

export default Contact;